import { useEffect, useState } from "react";
import { fetchSchoolCurrentTerm } from "../utils/currentTermUtils";
import { TERM_RECORDS_SCOPES } from "../utils/termRecordsScope";

/** Current term / past records toggle shared across admin & teacher working screens. */
export function useTermRecordsScope(schoolId) {
    const [recordsScope, setRecordsScope] = useState(TERM_RECORDS_SCOPES.CURRENT);
    const [currentTermLabel, setCurrentTermLabel] = useState("");
    const [currentTerm, setCurrentTerm] = useState("");
    const [currentAcademicYear, setCurrentAcademicYear] = useState("");

    useEffect(() => {
        if (!schoolId) {
            setCurrentTermLabel("");
            setCurrentTerm("");
            setCurrentAcademicYear("");
            return;
        }
        fetchSchoolCurrentTerm({ schoolId, includeFees: false })
            .then((info) => {
                setCurrentTermLabel(info?.label || "");
                setCurrentTerm(info?.term || "");
                setCurrentAcademicYear(info?.academicYear || "");
            })
            .catch(() => {
                setCurrentTermLabel("");
                setCurrentTerm("");
                setCurrentAcademicYear("");
            });
    }, [schoolId]);

    return {
        recordsScope,
        setRecordsScope,
        currentTermLabel,
        currentTerm,
        currentAcademicYear,
    };
}
